// common/services/types/listTeamOfficialTypes.ts
//
// GET /sports/:sportId/types, narrowed to the team-official role vocabulary
// ({id, name, name_full} — e.g. 1 → "Manager"). The endpoint returns a list of
// single-key groups (`[{ player_types: [...] }, { team_official_types: [...] }]`);
// we also tolerate a { data: [...] } wrapper.

import req from '../../api/request'

export type TeamOfficialType = {
  id: number
  name: string | null
  name_full: string | null
}

type TypeGroup = { team_official_types?: TeamOfficialType[] }

export const listTeamOfficialTypes = async (
  sportId: string
): Promise<TeamOfficialType[]> => {
  const response = await req(`/sports/${sportId}/types`)
  const groups: TypeGroup[] = Array.isArray(response)
    ? response
    : Array.isArray((response as { data?: unknown })?.data)
    ? (response as { data: TypeGroup[] }).data
    : []
  return (
    groups.find((group) => Array.isArray(group?.team_official_types))
      ?.team_official_types ?? []
  )
}
